module.exports = __webpack_public_path__ + "img/4-4.6ef33fa5.png";